import { render, staticRenderFns } from "./TaskEditModal.vue?vue&type=template&id=271536f3&"
import script from "./TaskEditModal.vue?vue&type=script&lang=js&"
export * from "./TaskEditModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271536f3')) {
      api.createRecord('271536f3', component.options)
    } else {
      api.reload('271536f3', component.options)
    }
    module.hot.accept("./TaskEditModal.vue?vue&type=template&id=271536f3&", function () {
      api.rerender('271536f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/components/tasks/TaskEditModal.vue"
export default component.exports